import CurrencyInput from "components/form/currency-input";
import clsx from "clsx";
import { useDiscountCreate } from "contexts/v1/pages/DiscountCreateContext";
import Select from "react-select";
import { useEffect } from "react";
import { ACTION_TYPES, DISCOUNT_TYPES } from "utils/constants";

const DiscountCreate = ({ initialData, onSuccess, onError }) => {
    const { discount, setDiscount, createDiscount, updateDiscount } = useDiscountCreate();

    useEffect(() => {
        if (initialData) {
            setDiscount((prevState) => ({
                ...prevState,
                form: {
                    name: initialData.name,
                    type: initialData.type,
                    value: initialData.value
                },
                data: initialData,
                mode: ACTION_TYPES.EDIT,
            }));
        }
    }, [initialData]);

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            if (discount.mode === ACTION_TYPES.CREATE) {
                createDiscount().then((response) => {
                    if (response.success) {
                        onSuccess();
                    } else {
                        onError(response.error);
                    }
                });
            } else {
                updateDiscount(discount.data.id).then((response) => {
                    if (response.success) {
                        onSuccess();
                    } else {
                        onError(response.error);
                    }
                });
            }
        }} className="d-flex flex-column" style={{ height: '100%' }}>
            <div className="action-sheet-content flex-grow-1">
                <div className="row mb-3 align-items-center">
                    <label htmlFor="name" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Name:</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", discount.error?.name && 'is-invalid')}
                            id="name"
                            placeholder="Name"
                            name="name"
                            value={discount.form.name}
                            onChange={(e) => setDiscount((prevState) => ({ ...prevState, form: { ...prevState.form, name: e.target.value } }))}
                            disabled={discount.isSubmitting}
                            style={{ fontSize: '14px', height: '35px' }}
                        />
                        {discount.error?.name && <div className="invalid-feedback">{discount.error.name}</div>}
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label htmlFor="type" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Type:</label>
                    <div className="col-sm-8">
                        <Select
                            options={DISCOUNT_TYPES}
                            className={clsx(discount.error?.type && 'is-invalid')}
                            id="type"
                            name="type"
                            onChange={(e) => setDiscount((prevState) => ({ ...prevState, form: { ...prevState.form, type: e.value } }))}
                            disabled={discount.isSubmitting}
                            style={{ fontSize: '14px', height: '35px' }}
                            placeholder="Select Type"
                            value={
                                discount.form.type
                                    ? {
                                        value: discount.form.type,
                                        label: discount.form.type === DISCOUNT_TYPES[1].value ? DISCOUNT_TYPES[1].label : DISCOUNT_TYPES[0].label,
                                    }
                                    : null
                            }
                        />
                        {discount.error?.type && <div className="invalid-feedback">{discount.error.type}</div>}
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label htmlFor="value" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Value:</label>
                    <div className="col-sm-8">
                        {discount.form.type === 'percentage' ? (
                            <>
                                <input
                                    type="text"
                                    className={clsx("form-control gotra-form-control rounded-1", discount.error?.value && 'is-invalid')}
                                    id="value"
                                    placeholder="Value"
                                    name="value"
                                    value={discount.form.value}
                                    onChange={(e) => setDiscount((prevState) => ({ ...prevState, form: { ...prevState.form, value: e.target.value } }))}
                                    disabled={discount.isSubmitting}
                                    style={{ fontSize: '14px', height: '35px' }}
                                />
                                {discount.error?.value && <div className="invalid-feedback">{discount.error.value}</div>}
                            </>
                        ) : (
                            <CurrencyInput
                                className={clsx("form-control gotra-form-control rounded-1", discount.error?.value && 'is-invalid')}
                                id="value"
                                placeholder="Rp. 0"
                                name="value"
                                value={discount.form.value}
                                onChange={(e, rawValue) => setDiscount((prevState) => ({ ...prevState, form: { ...prevState.form, value: rawValue } }))}
                                disabled={discount.isSubmitting}
                                style={{ fontSize: '14px', height: '35px' }}
                                error={discount.error?.value}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className="form-group mt-auto d-grid">
                <button type="submit" className="btn btn-primary btn-block" disabled={discount.isSubmitting}>
                    {discount.mode === ACTION_TYPES.EDIT ? `${ACTION_TYPES.EDIT} Discount` : `${ACTION_TYPES.CREATE} Discount`}
                </button>
            </div>
        </form>
    )
};

export default DiscountCreate;